import { ModelEntity, BaseEntity, ParentEntity, StoragePersist, EntityIndex, CacheBase } from "../../core/baseEntity.model";
import { genVr } from "../../core/utils";
import { AuthService } from "../core-services/auth.service";

export interface AccountSettingsTrait {
    currency: 'USD' | 'BRL' | string,
    language: 'en-US' | 'pt-BR' | string,
    currencyFormat: 'symbol-narrow' | 'symbol' | 'code' | 'name' | string,
    dateFormat: 'MM/dd/YYYY' | 'dd/MM/YYYY' | string,
    amountFormat: '1.2-2' | '1.2-0' | '1.0-0' | string,
    appointmentDuration: number;
    appointmentPrice: number; 
    schedule?: {
        start: number;
        end: number;
    }
}

@ModelEntity({ 
    name: "users",
    storagePersist: true,
    databasePersist: true,
    parentName: null
})
export class AccountEntity extends BaseEntity<AccountEntity> {

    @EntityIndex()
    public email: string;
    
    public name: string;

    @StoragePersist({
        name: "settings",
        default: {
            currency: navigator.language == 'pt-BR' ? 'BRL' : 'USD',
            language:  navigator.language || 'en-US',
            currencyFormat: 'symbol-narrow',
            dateFormat: 'MM/dd/YYYY',
            amountFormat: '1.2-2',
            appointmentDuration: 30,
            appointmentPrice: 100,
            schedule: {
                start: 7,
                end: 22
            }
        }
    })
    public settings: AccountSettingsTrait;


    //
    export<AccountEntity>(excludeSplittedStorage?: boolean): AccountEntity {
        return {
            id: this.id,
            email: this.email,
            name: this.name,
            settings: !excludeSplittedStorage ? this.settings : undefined
        } as any;
    }
}

export const UserCache = class extends CacheBase {
    static get canonical() {
       return 'u';
    }

    static ref(id: string = AuthService.instance.currentUser?.uid) {
        return `${this.canonical}/${id}`;
    }   
    
}
